import { styled } from "@mui/material";
import { colors, fonts } from "@constants/cssVariables";

export const SocialMediaContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(4),
}));

export const SocialMediaTitle = styled("p")(() => ({
  font: fonts.header5,
  color: colors.neutral0,
}));

export const SocialMediaItemsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(4),

  [theme.breakpoints.up("md")]: {
    gap: theme.spacing(3),
  },
}));
